import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function CartActive(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.001 4.127H5.856l-.245-1.311A1 1 0 004.628 2H2a1 1 0 000 2h1.798l1.795 9.576a1 1 0 00.025.129l.065.349c.176 1.54 1.132 4.15 3.603 4.15h11.54a1 1 0 000-2H9.285c-.867 0-1.296-1.057-1.489-1.783l11.425-.327c1.8-.231 2.681-1.238 3.112-2.44a7.989 7.989 0 01-2.785.334 2.25 2.25 0 01-.482.114L7.41 12.43l-1.18-6.304h6.055a7.99 7.99 0 01-.285-2zm-.782 16.69c0-.804-.655-1.46-1.46-1.46a1.46 1.46 0 101.46 1.46zm9.335 0c0-.804-.655-1.46-1.46-1.46-.805 0-1.46.656-1.46 1.46a1.46 1.46 0 002.92 0z",
    fill: props.color || "#222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4z",
    fill: "#F81B40"
  }));
}
var MemoCartActive = React.memo(CartActive);
export default MemoCartActive;